import {Modal} from 'antd-mobile'

import { jumpTo } from '@/utils'
import React, { useState, useImperativeHandle, forwardRef} from 'react'

import styled from "styled-components";

import './styles.css'

const BuyModal = forwardRef((props, ref) => {
  const [visible,setVisible ] = useState(false)
  const [showType,setShowType ] = useState(null)
  const [selected,  setSelected] = useState(0)
  const { skuInfo } = props

  const href = 'https://www.wogoo.com/essay/#/?articleId=1011f5c2e91d4bcf815115ee5baa9979&articleType=1'
  
  const goods = [
    {
      img: require('../images/buy/0.png'),
      selected: require('../images/buy/buy0.png'),
    },
    {
      img: require('../images/buy/1.png'),
      selected: require('../images/buy/buy1.png'),
    },
   
    {
      img: require('../images/buy/3.png'),
      selected: require('../images/buy/buy3.png'),
    },
    {
      img: require('../images/buy/2.png'),
      selected: require('../images/buy/buy2.png'),
    },
  ]
  const goHref = () => {
    jumpTo(href)
  }
  const handleClose = () => {
    setVisible(false)
    console.log('showType: close', showType);
    if(!showType) {
      
      props.onClose()
    }
   }
  
  useImperativeHandle(ref, () => ({
    show: ( val) => {
      console.log('val ', val);
      setVisible(true)
      setSelected(0)

      setShowType(val)
       
    },
    hide: () => {
      
      handleClose()
      // setVisible(false)
    }
   }));

 const handleBuy = () => {
  const info = skuInfo[selected]
  props.onBuy(info)
 }
  return (
    <Modal 
    visible={visible} 

    transparent
    wrapClassName={'buyContentModal'}

     onClose={() => handleClose()}
  
     >
     <ContentModal>
        <div className='title'>
          <div onClick={() => handleClose()}>
            <img src={require('../images/buy/close.png')} alt='' />
          </div>
          <div onClick={()=> {goHref()}}>了解会员</div>
        </div>
        <div className='tips'>购买以下任意会员后即刻解锁奖励，并获6次抽奖</div>

        <div className='goods_box'>

          {
            goods.map((good, index) =>{
              return   (
                <div>
                 <img onClick={()=>setSelected(index)} src={ selected !== index ? good.img: good.selected} alt=''></img>
                 </div>
            )
            })
          }
         
        </div>
        
        <div className='btn' onClick={handleBuy}>
          <img  src={require('../images/buy.png')} alt=''/>
        </div>

     </ContentModal>
</Modal>
  )
})
export default BuyModal;


const ContentModal = styled.div`

.title {
  display: flex;
  justify-content: space-between;
  img {
    width: 12px;
  }
}
.tips {
  font-size: 15px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #B2B1B9;
  line-height: 20px;
  padding: 15px 0 20px;
}

.goods_box {
  display: flex;
  justify-content: space-between;
  div {
    flex: 1;
    width: 20px;
    // background-color: #ddd; 
    +div{
      margin-left: 13px;
    }
  }
  
  img {
    width: 100%;
    vertical-align: middle;
    // width: 60px;
    // height: 103px;
  }
  
}

.btn {
  margin-top: 15px;
  width: 100%;
  >img {
    width: 100%;
  }
}

`


// WEBPACK FOOTER //
// ./src/views/activity_41/components/buyModal.js